import { Component } from '@angular/core';
import { OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AlertsService } from '../../services/alerts.service';
import { UserService } from '../../services/user.service';
import { ProductService } from '../../services/product.service';
import { MetadataService } from '../../services/metadata.service';

/**
 * Component for printing selected products.
 */
@Component({
	selector: 'print-results',
	templateUrl: './print-results.component.html',
	styleUrl: './print-results.component.css'
})
export class PrintResultsComponent implements OnInit {
	@Input() productGroup: any;

	LOCALIZATION: any;
	input = {
		format: 'txt',
		allMetadata: true
	};

	constructor(
		private userService: UserService,
		private alertsService: AlertsService,
		private productService: ProductService,
		private metadataService: MetadataService,
		private ngbmodalService: NgbActiveModal
	) { }

	ngOnInit(): void {
		console.log('productGroup:', this.productGroup);

		this.LOCALIZATION = this.userService.LOCALIZATION;
	}

	/**
	 * Fetches the data for printing.
	 */
	print(): void {
		var payload = {
			format: this.input.format,
			allMetadata: this.input.allMetadata
		};

		this.productService.printProductMetadata(this.productGroup.ids, payload).then(
			(response: any) => {
				this.metadataService.printMetadata(response, this.LOCALIZATION.printResults);
				this.close();
			},
			() => {
				this.alertsService.error({
					message: "Failed to print the results."
				});
				this.close();
			}
		);
	}

	/**
	 * Closes the modal.
	 */
	close(): void {
		this.ngbmodalService.dismiss();
	}
}
